<template>
  <div>
    <div v-if="drawerState && links.length" class="mx-5 mt-3" style="color: white;font-size: small; font-weight: bold">
      MENU
    </div>
    <v-list nav :dense="drawerState" v-if="loading">
      <template v-for="(item, index) in menuLinks">
        <v-list-item
          :key="index"
          link
          :to="{ name: item.route }"
          @click="navigate(item)"
          exact
          v-permission="item.text"
        >
          <template v-if="drawerState ">
            <v-list-item-icon class="ml-4">
              <v-icon medium color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: white">{{ $t(item.title) }}</v-list-item-title>
          </template>
          <div v-else>
            <v-menu open-on-hover class="mb-1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon
                       dark
                       v-bind="attrs"
                       v-on="on"
                >
                  <v-icon color="white" medium>{{ item.icon }}</v-icon>
                </v-btn>
              </template>

              <v-list dense flat width="300">
                <v-list-item link
                             :to="{ name: item.route }"
                >
                  <v-list-item-icon>
                    <v-icon medium>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import isValidateFeatureFlag from '@/helpers/validate-feature-flag'

export default {
  name: 'MenuItems',
  data () {
    return {
      links: [
        {
          title: 'menu.dashboard',
          route: 'Dashboard',
          text: '',
          icon: 'mdi-home-outline'
        },
        {
          title: 'menu.quote',
          route: 'Quotation',
          text: 'create quote',
          icon: 'mdi-file-document-outline'
        },
        {
          title: 'menu.my_quotations',
          route: 'Quotations',
          text: 'view your aforders',
          icon: 'mdi-file-chart-outline'
        },
        {
          title: 'menu.my_bookings',
          route: 'Aforders',
          text: 'view your aforders',
          icon: 'mdi-book-outline'
        },
        {
          title: 'menu.financials',
          route: 'Invoicing',
          text: 'view your financials info',
          icon: 'mdi-cash-multiple'
        },
        {
          title: 'menu.support',
          route: 'Support',
          text: 'view your financials info',
          icon: 'mdi-email-outline'
        }
      ],
      links_admin: [
        {
          title: 'menu.dashboard',
          route: 'Dashboard',
          text: '',
          icon: 'mdi-home-outline'
        },
        {
          title: 'menu.quote',
          route: 'Quotation',
          text: 'create quote',
          icon: 'mdi-file-document-outline'
        },
        {
          title: 'menu.my_quotations',
          route: 'Quotations',
          text: 'view your aforders',
          icon: 'mdi-file-chart-outline'
        },
        {
          title: 'menu.my_bookings',
          route: 'Aforders',
          text: 'view your aforders',
          icon: 'mdi-book-outline'
        },
        {
          title: 'menu.users',
          route: 'Users',
          text: 'view your users',
          icon: 'mdi-account-outline'
        },
        {
          title: 'menu.financials',
          route: 'Invoicing',
          text: 'view your financials info',
          icon: 'mdi-cash-multiple'
        },
        {
          title: 'menu.support',
          route: 'Support',
          text: 'view your financials info',
          icon: 'mdi-email-outline'
        }
      ],
      availableClientsLogicoins: [
        'ETT',
        'FIT',
        'MUI',
        'CSO'
      ],
      loading: false,
      rol: null
    }
  },
  props: {
    drawerState: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    logicoinsAvailable () {
      return this.availableClientsLogicoins.includes(this.userLogged.client.code)
    },
    userLogged () {
      return this.$store.getters.userLogged
    },
    menuLinks () {
      return this.rol === 'Client Admin' ? this.links_admin : this.links
    }
  },
  async mounted () {
    await this.mountedSetup()
    this.loading = true

    const isActiveFeatureFlag = await isValidateFeatureFlag('active-logicoins', this.userLogged.client.id)

    if (!isActiveFeatureFlag) {
      this.links = this.links.filter(item => item.title !== 'menu.logikoins')
      this.$forceUpdate()
    }
    this.loading = true
  },

  methods: {
    can (val) {
      return this.$can(val)
    },
    navigate (item) {
      this.$emit('drawer-state-changed', false)
      this.$router.push({ name: item.route })
    },
    async waitForRole (retries = 10, interval = 300) {
      let attempts = 0
      return new Promise((resolve, reject) => {
        const check = () => {
          const authConfigRaw = localStorage.getItem('authConfig')
          if (authConfigRaw) {
            try {
              const authConfig = JSON.parse(authConfigRaw)
              const role = authConfig?.roles?.[0]
              if (role) {
                resolve(role)
                return
              }
            } catch (err) {
            }
          }

          attempts++
          if (attempts >= retries) {
            reject(new Error('Rol no disponible después del tiempo de espera'))
          } else {
            setTimeout(check, interval)
          }
        }
        check()
      })
    },

    async mountedSetup () {
      try {
        this.rol = await this.waitForRole()
        this.loading = false
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>

<style scoped>
.v-list-item.v-list-item--active .v-icon {
  color: #EDE939 !important;
}
</style>
